import { createReducer, on } from '@ngrx/store'
import { filter, isEqual, sumBy, uniq, map } from 'lodash-es'
import { createEntityAdapter, EntityState } from '@ngrx/entity'

import * as MatchedOffersViewActions from './matched-offers-view.actions'
import { ElasticSearchFilters } from 'src/services/elastic-search'
import { prepareMatchedOffersPayload } from './matched-offers-view-filters.utils'


export const matchedOffersViewsFeatureKey = 'matchedOffersViews'

export interface MatchedOffersViewsState extends EntityState<any> {
  filters: Dictionary<ElasticSearchFilters>
  prevQuery: Dictionary<any>
  // receipt ids lists grouped by table key
  tables: Dictionary<string[]>
  // total MatchedOffers lists grouped by table key
  totals: Dictionary<Dictionary<any>>
  
}

const selectId = row => {
  return row.doc.matched_offer_id
}

export const adapter = createEntityAdapter<any>({ selectId })

const initialState: MatchedOffersViewsState = adapter.getInitialState({
  tables: {},
  totals: {},
  filters: {},
  prevQuery: {},
})

export const matchedOffersViewReducer = createReducer(
  initialState,
  on(MatchedOffersViewActions.loadMatchedOffersViews,
    (state, action) => {
      const key = action.tableKey
      const query = prepareMatchedOffersPayload(action.filters, action.page)
      const prev = state.prevQuery[key] || {}

      let { tables, totals, prevQuery } = state
      if (!isEqual(query.query, prev.query)) {
        tables = { ...tables, [key]: undefined } // drop table
        prevQuery = { ...prevQuery, [key]: query } // save query
  
      } else if (!isEqual(query.sort, prev.sort)) {
        // When sorting changes, keep the array but clear the data
        const table = state.tables[key]
        if (table) {
          tables = { ...tables, [key]: new Array(table.length) } // keep length, clear data
        }
        prevQuery = { ...prevQuery, [key]: query } // save query
      }
      return { ...state, tables, totals: {}, prevQuery }
    }),
  on(MatchedOffersViewActions.loadMatchedOffersViewsSuccess,
    (state, action) => {
      const key = action.tableKey
      const { total, totals: totals_, matchedOffers, payload: { skip, limit } } = action
      const dealIds = matchedOffers.map(selectId)

      // Optimize: Only create array if needed or size changed
      let table = state.tables[key]
      if (!table || table.length !== total) {
        // Only allocate when necessary
        table = new Array(total)
      } else {
        // Reuse existing array
        table = [...table]
      }
      
      // Fill only the loaded portion
      for (let i = 0; i < dealIds.length; i++) {
        table[skip + i] = dealIds[i]
      }
      
      const tables = { ...state.tables, [key]: table }
      const totals = { ...state.totals, [key]: totals_ }

      state = adapter.upsertMany(action.matchedOffers, state)
      return { ...state, tables, totals }
    }),
  on(MatchedOffersViewActions.loadMatchedOffersFiltersSuccess,
    (state, action) => {
      const key = action.tableKey
      const filters = { ...state.filters, [key]: action.result }
      return { ...state, filters }
    }),
)

